// Types
import { Selector } from 'react-redux';
import { EditorInstanceObject, TiptapEditorStoreState } from './tiptapEditorStoreTypes';

export const getActiveTiptapEditor: Selector<TiptapEditorStoreState, EditorInstanceObject | null> = (state) =>
    state.activeEditor;
